import React, { useState } from "react";

const Tooltip = (props) => {
  let timeout;
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, 400);
  };

  const hideTip = () => {
    clearTimeout(timeout); // Fixed: was clearInterval
    setActive(false);
  };
 
  const tooltipClass = props.variant=== 'detail' ? 'Tooltip-Tip-Detail' :   props.variant === 'test' ? 'Tooltip-Tip-Tests' : 'Tooltip-Tip';
  
  return (
    <div className="Tooltip-Wrapper"
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {props.children}
      {active && (
        <div className={tooltipClass}>
          {props.content}
        </div>
      )}
    </div>
  );
};

// Export both default and named for backward compatibility
export default Tooltip;
export const Tooltip_detail = (props) => <Tooltip {...props} variant="detail"/>;
